var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-padding "},[_c('CTicketForm',{attrs:{"current_user":_vm.current_user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }